/* ================================================================
   ZZ MARTS - CART: TRUST BLOCK, SAME-DAY NUDGE, CONTINUE SHOPPING,
              QTY FIX, DELIVERY BAR
   ================================================================
   Injects, above the checkout button on BOTH the side cart and /cart:
     1. A short trust list plus one WhatsApp line
     2. The same-day delivery notice
     3. "Continue shopping" under the button - drawer only
     4. The free delivery progress bar - /cart only (the drawer's own
        copy is drawn by zz-cart.js)
   And fixes the quantity control - TRAP 24 below.

   WHY JAVASCRIPT AND NOT LIQUID: the right Liquid home is
   snippets/cart-summary.liquid, which renders the checkout button on
   both surfaces. That file is 18KB of core Horizon, and a slip in it
   breaks checkout - the one page where a mistake costs an order
   rather than a click. Injecting means a failure loses a
   reassurance, not a function. That is the correct way round.

   WHY THE CSS IS IN HERE: a new stylesheet only loads if something
   registers it in snippets/zz-head.liquid, which renders in the head
   of every page. Editing a 16KB head snippet to register one small
   file risks the whole site's CSS, JS and structured data to fix one
   drawer. This file is already loaded and its blast radius is the
   cart.

   ================================================================
   >>> THE FOOTER HAS BEEN OVERFILLED THREE TIMES. READ THIS. <<<
   ================================================================
   This block is the most-edited thing in the theme and every edit
   has pushed the drawer footer taller. The history, because it keeps
   repeating:

     Aug    Seven WRAPPED trust lines. With the delivery bar, the
            discount row and the totals, the footer took 58% of the
            panel and the customer could see one and a half of their
            own items. Cut to four one-line rows.
     26 Sep Same-day added as a fifth row.
     30 Sep 4% added as a sixth row.
     30 Sep Same-day promoted out of the list into its own notice,
            and the owner said the drawer was crowded again. Cut to
            THREE rows plus a one-line WhatsApp.

   TWO RULES, both learned by measuring rather than by opinion:

     A. EVERY TRUST ROW MUST FIT ON ONE LINE. The 58% footer was
        caused by wrapping, not by the number of rows. At 0.75rem in
        a 432px drawer that means about 42 characters. Measure the
        rendered drawer after changing this copy.

     B. NOTHING GOES IN TWICE. Checked on 30 Sep and this is what
        earned the cut: the progress bar says "Add Rs X more for free
        delivery" and a trust row said "Free delivery over Rs 5,000"
        about 120px below it. One fact, stated twice, in a footer
        already too tall. The bar is better at it - it shows the gap
        - so the row went.

   WHAT SURVIVED THE 30 Sep CUT, and why each one earns its row:

     Cash on delivery, you pay the courier   the actual fear behind
                                             COD in this market
     Code PREPAID4, 4% off                   the only ACTIONABLE line,
                                             and it sits next to the
                                             discount field it needs
     2-3 day delivery + 7-day returns        merged: both are "what
                                             happens after I pay"

   WHAT WAS CUT: the free-delivery row (rule B), and the WhatsApp
   line dropped from two lines to one.

   DO NOT ADD A FOURTH ROW without removing one. If something new has
   to be said, the honest question is which existing line it beats.

   ================================================================
   >>> THE SAME-DAY NOTICE IS A MOVE, NOT AN ADDITION <<<
   ================================================================
   Asked for on 30 Sep: customers only discovered same-day existed
   once they reached the checkout's shipping step.

   The obvious build is a highlighted strip ALONGSIDE the existing
   "Same-day in Karachi & Lahore if prepaid" trust row. That breaks
   rule B. So the row was removed and promoted into its own block
   immediately above the checkout button, where it is the last thing
   read before the tap.

   >>> IT IS A NOTICE, NOT A BUTTON. DO NOT MAKE IT ONE. <<<
   The shipping rate is chosen on Shopify's checkout and there is no
   cart API for shipping method, so nothing here can pre-select it. A
   button would either do nothing or fake it, and a dead control next
   to Checkout is worse than no control. Hence no cursor:pointer, no
   hover state, and the verb is deferred: "choose it at checkout".

   >>> THE PRICE STAYS IN THE COPY. <<<
   "+Rs 500" is deliberate. Promoting a paid upgrade without naming
   the cost is a dark pattern, and here it would also backfire: the
   customer finds the charge one screen later, exactly when they are
   deciding whether to trust a COD shop they have not used before.

   ================================================================
   >>> TRAP 24 - .cart-items__quantity-controls IS NOT THE CONTROL <<<
   ================================================================
   The class name lies. Horizon nests TWO things inside it:

     .cart-items__quantity-controls        <- wrapper
       .quantity-selector-wrapper
         cart-quantity-selector-component  <- the actual control
           button.quantity-minus           (icon 14px)
           input
           button.quantity-plus            (icon 14px)
       button.cart-items__remove           (icon 20px)  <- ALSO INSIDE

   zz-cart.css put the pill - border, radius, white fill, padding -
   on the WRAPPER and sized every descendant button to 26x26. So the
   Remove bin was swallowed into the same capsule as plus and minus
   and read as a third quantity button; and because Horizon ships the
   bin at 20px against their 14px, it looked jammed and oversized.
   Together that was "the quantity button looks broken".

   The fix puts the pill where the control actually is: the wrapper
   becomes a plain flex row, .quantity-selector gets the pill, the
   bin sits outside it. Icon sizes are normalised so nothing depends
   on Horizon shipping matched icons. Buttons went back to 28px - the
   26px was to save footer height and it shrank a control people have
   to hit accurately on a phone, for two pixels.

   If you restyle this, check what is INSIDE the element first.

   ================================================================
   >>> CONTINUE SHOPPING CLOSES THE DRAWER, IT DOES NOT NAVIGATE <<<
   ================================================================
   A link to /collections/all would be wrong: the customer is part
   way through a product or collection page, and sending them to a
   generic list loses their place and their scroll position, which is
   the opposite of "continue shopping".

   So it CLOSES the drawer and leaves them where they were, by
   clicking Horizon's own close button rather than calling a
   component method - the close button is plain markup unlikely to
   change, while the component API is internal and has caught us out
   before (TRAP 10 in zz-cart.css). If that button is missing the
   handler does nothing rather than throwing.

   Quiet text link, not a second button: two equal buttons make the
   customer choose, and the primary action must stay primary.

   ================================================================
   THINGS THAT LOOK LIKE TIDYING BUT ARE NOT
   ================================================================
   THE PHONE NUMBER IS GONE ON PURPOSE. Printing 0308 3260009 as link
   text wrapped mid-number in a 432px drawer - "0308" on one line,
   "3260009" on the next - which reads as broken and, worse, as a
   number you cannot trust to be complete. Do not put the digits back
   as link text.

   THE FREE DELIVERY LINE IS CONDITIONAL. It reads "Free delivery on
   this order" only once the cart qualifies; otherwise the bar states
   the gap. Telling someone with Rs 900 in their basket that delivery
   is free is a promise checkout then breaks.

   THE SAME-DAY AND 4% COPY IS NOT CONDITIONAL, deliberately. The
   cart cannot know whether every line item is eligible - the bulky
   and quote-mode exclusions live in snippets/zz-sameday.liquid and
   are per-product - so the cart states the offers and their
   conditions rather than promising they apply to this basket. Do not
   rewrite as "your order will arrive today"; that needs a per-item
   check this file cannot do.

   THE 4% IS A CODE, NOT AUTOMATIC. Shopify discounts cannot read the
   payment method, because payment is chosen after discounts. The
   customer types PREPAID4 into the cart's own discount field, which
   is exactly why naming it here earns its row. Nothing stops a COD
   customer using it; that is caught by the confirmation call.

   THE THRESHOLD IS READ, NOT DECLARED. window.ZZ_FREE_SHIP comes
   from zz-cart.js, which loads first. A drawer and a cart page
   promising different amounts is the class of bug this theme keeps
   producing. The fallback exists only for zz-cart.js failing to load.

   THE Rs 500, THE 4PM CUT-OFF AND THE 4% are also in
   snippets/zz-sameday.liquid, templates/product.json,
   templates/index.json, the checkout rate's name and description,
   the PREPAID4 discount and the shipping policy. zz-sameday.liquid
   carries the full list. Change them together.

   WHY A MutationObserver: Horizon re-renders the cart summary
   wholesale on every change, so anything injected once on load is
   gone by the second interaction. Debounced with
   requestAnimationFrame because one cart update fires many
   mutations, and the data-attribute guards make insertion idempotent
   - without them the observer reacts to its own work and loops.
   ================================================================ */
(function () {
  'use strict';

  var MARK = 'data-zz-cart-trust';
  var SHIP = 'data-zz-ship';
  var CONT = 'data-zz-continue';
  var SDAY = 'data-zz-sameday-nudge';
  var WA = '923083260009';

  var ICONS = {
    wallet:  '<path d="M3 7h14a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M3 7V6a2 2 0 012-2h9"/><path d="M16 12h.01"/>',
    percent: '<path d="M19 5L5 19"/><circle cx="6.8" cy="6.8" r="2.6"/><circle cx="17.2" cy="17.2" r="2.6"/>',
    back:    '<path d="M3 10h11a5 5 0 010 10h-4"/><path d="M6.5 6.5L3 10l3.5 3.5"/>',
    bolt:    '<path d="M13 2.5L5.5 13.5H11l-1 8 8-11H12z"/>'
  };

  function threshold() {
    return (typeof window.ZZ_FREE_SHIP === 'number' && window.ZZ_FREE_SHIP > 0)
      ? window.ZZ_FREE_SHIP
      : 500000;
  }

  function rupees(paise) {
    return 'Rs ' + Math.ceil(paise / 100).toLocaleString('en-US');
  }

  /* ---------------- styles, injected once ----------------
     Appended to <head> at runtime, so it comes after every
     stylesheet_tag in document order and wins ties on load order.
     That is what lets it correct zz-cart.css without needing higher
     specificity or !important. */

  function injectStyles() {
    if (document.getElementById('zz-cart-trust-css')) return;
    var css = [
      /* ---- /cart page: the roomy version ---- */
      '.zzct{margin:0 0 12px;padding:13px 15px;border:1px solid var(--zz-border,#E9E6DE);',
      'border-radius:14px;background:var(--zz-muted-2,#FBFAF7);display:grid;gap:8px;width:100%;',
      'box-sizing:border-box;list-style:none}',
      '.zzct li{display:flex;align-items:flex-start;gap:10px;margin:0;font-size:0.8125rem;line-height:1.4;',
      'font-weight:550;color:var(--zz-ink,#17150F)}',
      '.zzct svg{width:17px;height:17px;flex:0 0 17px;margin-top:1px;color:var(--zz-accent-deep,#8A6A00)}',
      '.zzct li.is-free{color:var(--zz-accent-deep,#8A6A00);font-weight:650}',
      '.zzct__ask{margin:1px 0 0;padding-top:9px;border-top:1px solid var(--zz-border,#E9E6DE);',
      'font-size:0.78125rem;line-height:1.4;color:var(--zz-muted-fg,#6B6862);font-weight:450}',
      '.zzct__ask a{color:var(--zz-ink,#17150F);font-weight:650;text-decoration:underline;text-underline-offset:2px}',
      /* The code reads as something to copy. */
      '.zzct code{font:inherit;font-weight:700;letter-spacing:0.02em}',

      /* ---- the same-day notice ----
         Gold left border and warm tint, matching .zzprice__body on
         the product page, so it reads as the same kind of aside
         rather than a new visual language. NOT a button: no
         cursor:pointer, no hover lift. See the header. */
      '.zzsd{margin:0 0 12px;padding:10px 12px;border-inline-start:3px solid var(--zz-accent,#FFC400);',
      'border-radius:0 10px 10px 0;background:var(--zz-muted-2,#FBFAF7);box-sizing:border-box;width:100%}',
      '.zzsd__h{display:flex;align-items:center;gap:7px;margin:0 0 2px;font-size:0.8125rem;',
      'font-weight:700;color:var(--zz-ink,#17150F)}',
      '.zzsd__h svg{width:15px;height:15px;flex:0 0 15px;color:var(--zz-accent-deep,#8A6A00)}',
      '.zzsd__p{margin:0;font-size:0.78125rem;line-height:1.4;color:var(--zz-muted-fg,#6B6862)}',
      '.zzsd__p strong{color:var(--zz-ink,#17150F);font-weight:650}',
      '#cart-drawer .zzsd{margin:0 0 9px;padding:8px 10px}',
      '#cart-drawer .zzsd__h{font-size:0.78125rem;margin-bottom:1px}',
      '#cart-drawer .zzsd__p{font-size:0.75rem;line-height:1.35}',

      /* ---- drawer: the compact version ----
         No card, no border, no fill, and no rule above the WhatsApp
         line. In a panel this narrow a bordered box inside a tinted
         footer reads as clutter, and hairlines were exactly what the
         owner was seeing too many of. */
      '#cart-drawer .zzct{border:0;background:none;padding:0 0 9px;margin:0;gap:6px}',
      '#cart-drawer .zzct li{font-size:0.75rem;line-height:1.35;align-items:center;gap:9px;font-weight:500}',
      '#cart-drawer .zzct svg{width:15px;height:15px;flex:0 0 15px;margin-top:0}',
      '#cart-drawer .zzct__ask{border-top:0;padding-top:0;margin-top:4px;font-size:0.75rem;line-height:1.35}',

      /* Rule B in the header: the bar already states this once. */
      '#cart-drawer .zzcart__ship.is-unlocked{display:none}',

      /* ---- quantity control, see TRAP 24 ---- */
      '#cart-drawer .cart-items__quantity-controls{display:flex;align-items:center;gap:8px;',
      'padding:0;border:0;border-radius:0;background:none}',
      '#cart-drawer .cart-items__quantity-controls .quantity-selector-wrapper{display:inline-flex}',
      '#cart-drawer .cart-items__quantity-controls .quantity-selector{display:inline-flex;align-items:center;',
      'gap:2px;padding:2px;border:1px solid var(--zz-border,#E9E6DE);border-radius:999px;background:#fff}',
      '#cart-drawer .cart-items__quantity-controls button{width:28px;height:28px;min-width:28px;padding:0;',
      'border-radius:999px;display:grid;place-items:center;color:var(--zz-muted-fg,#6B6862);',
      'transition:background .16s ease,color .16s ease}',
      '#cart-drawer .cart-items__quantity-controls svg{width:14px;height:14px}',
      '#cart-drawer .cart-items__quantity-controls button:hover:not(:disabled){',
      'background:var(--zz-muted,#F5F3EE);color:var(--zz-ink,#17150F)}',
      '#cart-drawer .cart-items__quantity-controls button:disabled{opacity:.4;cursor:default}',
      '#cart-drawer .cart-items__quantity-controls input{width:30px;border:0;text-align:center;',
      'font-size:0.8125rem;font-weight:600;font-variant-numeric:tabular-nums;background:transparent;',
      'color:var(--zz-ink,#17150F)}',
      /* Red only on hover. A permanently red bin on every row makes a
         cart look like a list of mistakes. */
      '#cart-drawer .cart-items__remove{border:0;background:none;color:var(--zz-subtle-fg,#7A766D)}',
      '#cart-drawer .cart-items__remove:hover{background:#FDECEC;color:#C02626}',
      '#cart-drawer .cart-items__remove:focus-visible{outline:2px solid var(--zz-accent,#FFC400);outline-offset:2px}',

      /* ---- continue shopping ---- */
      '.zzcont{display:block;width:100%;margin:8px 0 0;padding:3px 0;background:none;border:0;',
      'font:inherit;font-size:0.8125rem;font-weight:550;line-height:1.4;text-align:center;',
      'color:var(--zz-muted-fg,#6B6862);cursor:pointer;text-decoration:underline;',
      'text-underline-offset:2px;text-decoration-color:rgba(23,21,15,.25);',
      'transition:color .16s ease,text-decoration-color .16s ease}',
      '.zzcont:hover{color:var(--zz-ink,#17150F);text-decoration-color:currentColor}',
      '.zzcont:focus-visible{outline:2px solid var(--zz-accent,#FFC400);outline-offset:3px;border-radius:6px}',

      /* Below about 400px the compact lines start to wrap anyway, so
         the type steps down rather than the layout breaking. */
      '@media (max-width:399px){#cart-drawer .zzct li{font-size:0.71875rem}#cart-drawer .zzsd__p{font-size:0.71875rem}}',
      '@media (max-width:479px){.zzct li{font-size:0.78125rem}}',

      /* ---- /cart page free delivery bar ---- */
      '.zzshipbar{margin:0 0 12px;width:100%;box-sizing:border-box}',
      '.zzshipbar__note{margin:0 0 7px;font-size:0.8125rem;font-weight:600;color:var(--zz-ink,#17150F)}',
      '.zzshipbar__track{height:6px;border-radius:999px;background:var(--zz-border,#E9E6DE);overflow:hidden}',
      '.zzshipbar__fill{display:block;height:100%;border-radius:999px;background:var(--zz-accent,#FFC400);',
      'transform-origin:left center;transform:scaleX(0);transition:transform .35s cubic-bezier(.16,1,.3,1)}',
      '.zzshipbar.is-unlocked .zzshipbar__fill{background:#1a9c5b}',
      '.zzshipbar.is-unlocked .zzshipbar__note{color:#147946}',
      '@media (prefers-reduced-motion:reduce){.zzshipbar__fill{transition:none}}'
    ].join('');
    var el = document.createElement('style');
    el.id = 'zz-cart-trust-css';
    el.textContent = css;
    document.head.appendChild(el);
  }

  /* ---------------- trust block ----------------
     THREE rows in the drawer, FOUR on /cart, plus one WhatsApp line.
     Read "THE FOOTER HAS BEEN OVERFILLED THREE TIMES" in the header
     before adding anything here.

     The free-delivery row was removed on 30 Sep because the progress
     bar directly above states the same fact - rule B. The is-free
     class it used is kept in the CSS because zz-cart.js still applies
     the gold confirmation styling in the drawer. */

  function buildTrust(cart, compact) {
    var items = compact
      ? [
          ['wallet',  'Cash on delivery — pay the courier, not us', ''],
          ['percent', 'Code <code>PREPAID4</code> — 4% off if you prepay', ''],
          ['back',    '2–3 day delivery · 7-day returns', '']
        ]
      : [
          ['wallet',  'Cash on delivery — you pay the courier, not us', ''],
          ['percent', 'Save 4% when you pay by card or bank deposit — use code <code>PREPAID4</code>', ''],
          ['back',    'Delivered in 2–3 working days to Karachi, Lahore and Islamabad', ''],
          ['back',    '7 days to return it if it is not right', '']
        ];

    var ul = document.createElement('ul');
    ul.className = 'zzct';
    ul.setAttribute(MARK, '');

    var html = '';
    for (var i = 0; i < items.length; i++) {
      html += '<li' + (items[i][2] ? ' class="' + items[i][2] + '"' : '') + '>' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"' +
              ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              ICONS[items[i][0]] + '</svg><span>' + items[i][1] + '</span></li>';
    }

    /* One line in the drawer. The longer version wrapped to two and
       that second line was pure padding. */
    html += '<li class="zzct__ask">' +
            (compact
              ? 'Questions? <a href="https://wa.me/' + WA + '" target="_blank" rel="noopener">WhatsApp us</a>'
              : 'Questions? <a href="https://wa.me/' + WA + '" target="_blank" rel="noopener">Message us on WhatsApp</a> — we usually reply within minutes.') +
            '</li>';

    ul.innerHTML = html;
    return ul;
  }

  /* ---------------- the same-day notice ----------------
     A notice, not a control. The price is named. See the header
     before changing either decision. */

  function buildSameDay(compact) {
    var el = document.createElement('div');
    el.className = 'zzsd';
    el.setAttribute(SDAY, '');
    el.innerHTML =
      '<p class="zzsd__h">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"' +
      ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS.bolt + '</svg>' +
      'Need it today?</p>' +
      '<p class="zzsd__p">' +
      (compact
        ? 'Pick <strong>same-day delivery</strong> at checkout. Karachi &amp; Lahore, prepaid, before 4pm. <strong>+Rs 500</strong>.'
        : 'Choose <strong>same-day delivery</strong> at the checkout shipping step. Karachi and Lahore city only, on prepaid orders placed before 4pm. <strong>+Rs 500</strong>.') +
      '</p>';
    return el;
  }

  /* ---------------- insertion ----------------
     Horizon renders the checkout control differently on the two
     surfaces, so several selectors are tried rather than assuming
     one. The blocks go above the BUTTON, not above the totals: the
     point is to answer "is this safe to press" at the moment the
     customer is deciding to press it. */

  var SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-testid="Checkout-button"]',
    '.cart__checkout-button',
    '.cart-summary__checkout-button'
  ];

  function findButtons() {
    var found = [];
    for (var i = 0; i < SELECTORS.length; i++) {
      var nodes = document.querySelectorAll(SELECTORS[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (found.indexOf(nodes[j]) === -1) found.push(nodes[j]);
      }
    }
    return found;
  }

  function anchorFor(btn) {
    /* Accelerated wallet buttons sit in their own container next to
       the real checkout button. Anchor to the outermost so blocks
       land above the whole group rather than wedged between two
       payment buttons. */
    return btn.closest('.cart__checkout-buttons, .cart-summary__buttons, .accelerated-checkout-block') || btn;
  }

  function applyTrust(cart) {
    var buttons = findButtons();
    for (var i = 0; i < buttons.length; i++) {
      var anchor = anchorFor(buttons[i]);
      var parent = anchor.parentElement;
      if (!parent) continue;
      var compact = !!anchor.closest('#cart-drawer');
      var existing = parent.querySelector(':scope > [' + MARK + ']');
      var fresh = buildTrust(cart, compact);
      if (existing) {
        if (existing.innerHTML !== fresh.innerHTML) existing.innerHTML = fresh.innerHTML;
      } else {
        parent.insertBefore(fresh, anchor);
      }
    }
  }

  /* After the trust list, immediately before the checkout button, so
     it is the last thing read before the tap. Static copy, inserted
     once rather than rebuilt. */

  function applySameDay(cart) {
    if (!cart || !cart.item_count) return;
    var buttons = findButtons();
    for (var i = 0; i < buttons.length; i++) {
      var anchor = anchorFor(buttons[i]);
      var parent = anchor.parentElement;
      if (!parent) continue;
      if (parent.querySelector(':scope > [' + SDAY + ']')) continue;
      parent.insertBefore(buildSameDay(!!anchor.closest('#cart-drawer')), anchor);
    }
  }

  /* ---------------- continue shopping, drawer only ----------------
     On /cart the customer already has the whole site around them, so
     a "continue shopping" control there is noise. In the drawer it is
     the missing exit that is not the small X in the corner. */

  function closeDrawer() {
    var btn = document.querySelector('#cart-drawer .theme-drawer__close-button');
    if (btn) btn.click();
  }

  function applyContinue() {
    var buttons = findButtons();
    for (var i = 0; i < buttons.length; i++) {
      var anchor = anchorFor(buttons[i]);
      if (!anchor.closest('#cart-drawer')) continue;
      var parent = anchor.parentElement;
      if (!parent) continue;
      if (parent.querySelector(':scope > [' + CONT + ']')) continue;

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zzcont';
      b.setAttribute(CONT, '');
      b.textContent = 'Continue shopping';
      b.addEventListener('click', closeDrawer);
      /* after the checkout button, never before it */
      if (anchor.nextSibling) parent.insertBefore(b, anchor.nextSibling);
      else parent.appendChild(b);
    }
  }

  /* ---------------- free delivery bar, /cart page only ----------------
     The drawer already has one drawn by zz-cart.js. Injecting a second
     into #cart-drawer would show two identical bars. */

  function applyShipBar(cart) {
    if (!cart) return;
    var buttons = findButtons();
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.closest('#cart-drawer')) continue;
      var anchor = anchorFor(btn);
      var parent = anchor.parentElement;
      if (!parent) continue;

      var bar = parent.querySelector(':scope > [' + SHIP + ']');
      if (!cart.item_count) { if (bar) bar.remove(); continue; }

      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'zzshipbar';
        bar.setAttribute(SHIP, '');
        bar.innerHTML = '<p class="zzshipbar__note"></p>' +
                        '<div class="zzshipbar__track"><span class="zzshipbar__fill"></span></div>';
        var trust = parent.querySelector(':scope > [' + MARK + ']');
        parent.insertBefore(bar, trust || anchor);
      }

      var t = threshold();
      var total = cart.total_price || 0;
      var unlocked = total >= t;
      bar.classList.toggle('is-unlocked', unlocked);
      bar.querySelector('.zzshipbar__note').textContent = unlocked
        ? 'Free delivery applied to this order.'
        : 'Add ' + rupees(t - total) + ' more for free delivery.';
      bar.querySelector('.zzshipbar__fill').style.transform =
        'scaleX(' + Math.min(1, total / t).toFixed(4) + ')';
    }
  }

  /* ---------------- lifecycle ---------------- */

  var syncing = false;
  function sync() {
    if (syncing || !findButtons().length) return;
    syncing = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        applyTrust(cart);
        applySameDay(cart);
        applyContinue();
        applyShipBar(cart);
      })
      .catch(function () {})
      .then(function () { syncing = false; });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }

  function start() {
    injectStyles();
    sync();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();